<template>
    <div class="square-container-3" v-if="showContractPage">
        <div class="main-square-3">
            <br>
            <div class="header-section3-3">
                <div class="header-title-3">Contract: {{ contractName }} </div>
                <div class="header-title-3">Rating: 90/100</div>

                <div class="header-sub-3">




                </div>
                <div class="header-content-3">




                </div>


            </div>
            <div class="section1-3">
                <div class="section1-head-3">Contract Information</div>
                <div class="section1-titles-3">
                    <div>Contract Address:</div>
                    <div class="date-3">Date Deployed:</div>
                    <div class="audit-3">Description: </div>


                </div>

                <div class="section1-content-3">
                    <div>{{ contractAddress }}</div>
                    <div class="content-name-3">2021-12-24 13:39:40{{ contractDate }}</div>
                    <div class="content-description-3"> MyERC20 is an ERC20 token.  {{ contractAudit }} </div>


                </div>
                <div class="button-container-3">
                        <button class="info-button">Functions</button>
                        <button class="info-button">Comments</button>
                        <button class="info-button">Events</button>
                        <button class="info-button">More Info</button>
                        <button class="info-button">Visualizations</button>
                    </div>
            </div>
            
            <div class="section2-3">
                <div class="section2-titles-3">

                </div>
                <div class="section1-titles-3">
                    <br>
                    <div class="functions-3">Functions:</div>

                </div>
                <br>
                <div class="function-grid">

                    <div v-for=" (name, index) in functionNames" :key="name" class="function-name"
                        @click="goToVerificationPage(index)">{{ name }} </div>
                </div>
            </div>


        </div>
    </div>

    <FunctionPage v-if="showVerificationPage" :contractId="contractId" :functionIndex="functionIndex">
    </FunctionPage>
</template>
  
<script>
//import VerificationPage from './VerificationPage.vue';
import FunctionPage from './FunctionPage.vue';

export default {
    components: {
        //VerificationPage,
        FunctionPage


    },

    props: {
        contractId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            contractName: '',
            contractAddress: '',
            contractDate: '',
            contractAudit: '',
            selectedContractId: null,
            functionNames: '',
            showVerificationPage: false,
            showContractPage: true,
        };
    },
    mounted() {
        this.getContractData();
    },

    methods: {
        async getContractData() {





            const response = await fetch(`http://localhost:12345/api/v1/sourcify/${this.contractId}`); //0x00000000064Ecc11c97AC4a5551F279532Bf9E0D
            const data = await response.json();

            console.log(this.contractId);


            this.contractName = Object.values(data.settings.compilationTarget)[0];
            this.contractAddress = data._id;
            this.contractDate = data.timestamp;
            this.contractAudit = data.audit;

            const abi = data.output.abi;

            // Extract the names of all functions in the ABI array
            this.functionNames = abi.filter(x => x.type === 'function').map(x => x.name);



            this.functionNumber = abi.filter(x => x.type === 'function').map((x, index) => index);


        },
        goToVerificationPage(index) {
            this.showVerificationPage = true;
            this.showContractPage = false;
            console.log(index);
            this.functionIndex = index;
            console.log(this.functionIndex);
            this.$router.push({
                name: 'VerificationPage', props: {
                    functionIndex: index

                }
            });
            console.log(this.functionNumber);
        },
        closeVerificationPage() {
            this.showVerificationPage = false;
            this.$router.push({ name: 'home' });
        },
    }
};
</script>
  
<style>
.square-container-3 {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
}

.main-square-3 {
    width: 80%;
    height: 80%;
    bottom: 0%;

    border-radius: .5%;
    display: grid;
    grid-template-rows: 15% 45% 20% 20%;
    grid-template-columns: 100%;
    grid-template-areas:
        "header"
        "section1"
        "section2"
        "section3"




    ;
    position: relative;
}

/*.main-square-3 {
    width: 1200px;
    height: 900px;
    background-color: rgb(238, 238, 238);
    border-radius: 1%;
    display: grid;
    grid-template-rows: 15% 45% 20% 20%;
    grid-template-columns: 100%;
    grid-template-areas:
        "header"
        "section1"
        "section2"
        "section3"
    ;
    position: relative;
}

.main-square-3::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 15%;
    border-bottom: 3px solid black;
}

.main-square-3::after {
    content: "";
    position: absolute;
    top: 0;
    left: 100%;
    width: 1px;
    top: 10%;
    height: 85%;


}
*/

.header-section3-3 {
    grid-area: header;



}

.header-title-3 {
    text-align: left;
    padding-top: .0%;
    font-weight: bold;
    font-size: 24pt;


}

.header-sub-3 {
    width: 15%;
    /* or another width that you prefer */
    float: left;
    clear: both;
    /* to make sure it starts below section1-head */
    text-align: left;
    padding-left: 2%;
    font-weight: bold;
}

.header-content-3 {
    width: 70%;
    /* or another width that you prefer */
    float: left;
    text-align: left;
}


.section1-3 {
    grid-area: section1;
    border-bottom: 3px solid black;
    width: 100%;
    border-top: 3px solid black;

}

.section1-head-3 {
    text-align: center;
    padding-top: .0%;
    font-weight: bold;
    font-size: 24pt;
}

.section1-titles-3 div,
.section1-content-3 div {
    margin-bottom: 20px;
    padding-top: 10pt;
}


.section1-titles-3 {
    width: 15%;
    /* or another width that you prefer */
    float: left;
    clear: both;
    /* to make sure it starts below section1-head */
    text-align: left;
    padding-left: 2%;
    font-weight: bold;


}

.section1-content-3 {
    width: 70%;
    /* or another width that you prefer */
    float: left;
    text-align: left;
}



.section2-3 {
    grid-area: section2;

    width: 100%;

}

.section2-titles-3 {
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt;


}



.section3-3 {
    grid-area: section3;

    border-bottom-left-radius: 10px;

}

.section3-titles-3 {
    text-align: center;
    padding-top: .5%;
    font-weight: bold;
    font-size: 24pt
}





.toAddress-text-3,
.amount-text-3 {
    margin: 10px auto;
    /* add some space between the inputs */
    width: 80%;
    /* adjust as needed */
    padding: 10px;
    /* add some padding for the text */
    border-radius: 4px;
    /* adjust as needed */
    font-size: larger;
    /* adjust as needed */
    border: 2px solid black;
    /* adjust as needed */
}

.toAddress-text-3 {

    margin-bottom: 30px;
    margin-top: 50px;
}

.amount-text-3 {
    margin-bottom: 10px;
}

.send-button-3 {
    margin: 50px;
    padding: 10px 50px;
    font-size: 2rem;
    border-radius: 5px;
    border: black;
    background-color: #000000;
    /* Green */
    color: rgb(255, 255, 255);
}

.function-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
}

.function-name {

    padding: 10px;
}


.button-container-3 {
    position: absolute;
    top: 60%;
    right: 30%;
    transform: translateY(-50%);

}
.info-button {
    margin: 0 0px;
    border-radius: 0%;
    background-color: rgb(32, 31, 31);
    border-color: white;
    z-index: 2;
  }
</style>
  //  .flow-name {
    font-weight: bold;
    text-align: left;
}
.flow-description {
    font-weight: bold;
    text-align: left; 
}
.flow-ranking {
    font-weight: bold;
    text-align: left;
}
.flow-comments {
    font-weight: bold;
    text-align: left;
}